import CorrectCircleIcon from "#/assets/exam-results/CorrectCircle.svg?url";
import EmptyCircleIcon from "#/assets/exam-results/EmptyCircle.svg?url";
import WrongCircleIcon from "#/assets/exam-results/WrongCircle.svg?url";
import { DqModal } from "#/components/Question/DqModal";
import type {
  EducationPackExamQuestionDetail,
  FindSupplementaryExamResult
} from "#/services/rest/gwt/exam-results/exam-results.types";
import { useState } from "react";
import DifficultyLevel from "../DifficultyLevel/DifficultyLevel";
import QStatus from "../QStatus";
import styles from "./styles.module.scss";

const QuestionsTable = (props: {
  questions: EducationPackExamQuestionDetail[] | FindSupplementaryExamResult[];
}) => {
  const { questions } = props;

  const [questionModalId, setQuestionModalId] = useState<null | number>(null);

  return (
    <>
      <DqModal
        questionModalId={questionModalId}
        setQuestionModalId={setQuestionModalId}
      />
      <div className={styles["table"]}>
        <div className={styles["table__header"]}>
          <span>شماره سؤال</span>
          <span>گزینه‌ها</span>
          <span>سطح دشواری</span>
          <span>مبحث</span>
          <span>موضوع</span>
        </div>

        <div className={styles["table__content"]}>
          {questions.map((question, index) => (
            <div className={styles["table__content-row"]} key={index}>
              <div
                className={styles["table__content-row__order"]}
                onClick={() => {
                  setQuestionModalId(
                    question.questionId || question.questionID
                  );
                }}
              >
                <div className={styles["table__content-row__order-container"]}>
                  {!question.selectedChoiceOrder ? (
                    <img src={EmptyCircleIcon} alt="اصلا نزدی" />
                  ) : question.selectedChoiceOrder ===
                    question.correctChoiceOrder ? (
                    <img src={CorrectCircleIcon} alt="درست زدی" />
                  ) : (
                    <img src={WrongCircleIcon} alt="غلط زدی" />
                  )}
                  <span>{question.questionOrder}</span>
                </div>
              </div>
              <div className={styles["table__content-row__status"]}>
                <QStatus
                  correctChoice={question.correctChoiceOrder}
                  selectedChoice={question.selectedChoiceOrder}
                />
              </div>
              <div>
                <DifficultyLevel difficultyLevel={question.difficultyLevel} />
              </div>
              <div className={styles["table__content-row__mainTopic"]}>
                {question.mainTopic}
              </div>
              <div className={styles["table__content-row__subTopic"]}>
                {question.subTopic}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default QuestionsTable;
